import { createActionTypeModel } from "../../../../store/global/action-model";

export const AccountingSettingsData = createActionTypeModel('AccountingSettingsData');
export const MoneyAccounts = createActionTypeModel('MoneyAccounts');

export const CostGroups = createActionTypeModel('CostGroups');
export const IncomeGroups = createActionTypeModel('IncomeGroups');
export const Channels = createActionTypeModel('Channels');

export const TaxTypes = createActionTypeModel('TaxTypes');

export const TaxGroups = createActionTypeModel('TaxGroups');
export const TaxGroupItems = createActionTypeModel('TaxGroupItems');
export const VatProductCategory = createActionTypeModel('VatProductCategory');
export const SettingsAccountFormat = createActionTypeModel('SettingsAccountFormat');
export const SettingsAccountVatTerritory = createActionTypeModel('SettingsAccountVatTerritory');


